import BulletPoint from "@components/BulletPoint"
import { useTranslation } from "react-i18next"

export default function Features() {
  const { t } = useTranslation()

  return (
    <div className="space-y-11">
      <BulletPoint
        text={t("pages.onboarding.plans.benefitText_1")}
        title={t("pages.onboarding.plans.benefitHeader_1")}
      />

      <BulletPoint
        text={t("pages.onboarding.plans.benefitText_2")}
        title={t("pages.onboarding.plans.benefitHeader_2")}
      />

      <BulletPoint
        text={t("pages.onboarding.plans.benefitText_3")}
        title={t("pages.onboarding.plans.benefitHeader_3")}
      />

      <BulletPoint
        text={t("pages.onboarding.plans.benefitText_4")}
        title={t("pages.onboarding.plans.benefitHeader_4")}
      />
    </div>
  )
}
